import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/(app)/_main-layout/_compliance/compliance",
)({
  component: ComplianceLayoutRoute,
});

function ComplianceLayoutRoute() {
  return <Outlet />;
}
